module.exports = __webpack_public_path__ + "static/img/syfl-4.986f7e8d.jpg";